import { Component, Input } from '@angular/core';
import { ReferralMatchVerification } from '../../../core/models/referral-match-verification.model';
import { DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-validate-referral-match-verifications-prescriber-list',
    templateUrl: './validate-referral-match-verifications-prescriber-list.component.html',
    styleUrls: ['./validate-referral-match-verifications-prescriber-list.component.scss'],
    imports: [FaIconComponent, DatePipe]
})
export class ValidateReferralMatchVerificationsPrescriberListComponent {
  @Input() patientReferralMatchVerifications: ReferralMatchVerification[];
}
